import './Logo.css';

const Logo: React.FC = () => {
  return <div className="logo" />;
};

export default Logo;
